const confirmationStorageKey = 'departure-sub-confirmation';
const confirmationLifetimeMs = 30 * 60 * 1000;

export type DepartureSubConfirmation = {
  acceptedChildGlobalId: string;
  createdAt: number;
};

type ConfirmationStorage = Pick<Storage, 'getItem' | 'setItem'>;

export const saveDepartureSubConfirmation = (
  confirmation: Omit<DepartureSubConfirmation, 'createdAt'>,
  storage: ConfirmationStorage = sessionStorage,
  now: number = Date.now(),
): void => {
  storage.setItem(
    confirmationStorageKey,
    JSON.stringify({ ...confirmation, createdAt: now }),
  );
};

export const getDepartureSubConfirmation = ({
  acceptedChildGlobalId,
  storage = sessionStorage,
  now = Date.now(),
}: {
  acceptedChildGlobalId: string;
  storage?: ConfirmationStorage;
  now?: number;
}): DepartureSubConfirmation | undefined => {
  try {
    const stored = JSON.parse(
      storage.getItem(confirmationStorageKey) ?? '',
    ) as Partial<DepartureSubConfirmation>;
    const isCurrent =
      typeof stored.createdAt === 'number' &&
      now - stored.createdAt <= confirmationLifetimeMs;
    const isExpectedDecision =
      stored.acceptedChildGlobalId === acceptedChildGlobalId;

    return isCurrent && isExpectedDecision
      ? (stored as DepartureSubConfirmation)
      : undefined;
  } catch {
    return undefined;
  }
};
